import convertApi from "./portfolioApi";
import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";

export const getPortfolioInvestmentForm = createThunkFromApi(
  "convert/getPortfolioInvestmentForm",
  convertApi.getPortfolioInvestmentForm
);

export const getPortfolioTradeAvgForm = createThunkFromApi(
  "convert/getPortfolioTradeAvgForm",
  convertApi.getPortfolioTradeAvgForm
);

export const getPortfolioChart = createThunkFromApi(
  "convert/getPortfolioChart",
  convertApi.getPortfolioChart
);

export const getPortfolioTradeAvgList = createThunkFromApi(
  "convert/getPortfolioTradeAvgList",
  convertApi.getPortfolioTradeAvgList
);

export const getPortfolioInvestmentList = createThunkFromApi(
  "convert/getPortfolioInvestmentList",
  convertApi.getPortfolioInvestmentList
);

export const getPortfolioTradeAvgForCoinList = createThunkFromApi(
  "convert/getPortfolioTradeAvgForCoinList",
  convertApi.getPortfolioTradeAvgForCoinList
);

export const getPortfolioTradeAvgForCoin = createThunkFromApi(
  "convert/getPortfolioTradeAvgForCoin",
  convertApi.getPortfolioTradeAvgForCoin
);

const initialState = {
  portfolioForm: null,
  portfolioChart: null,
  portfolioTradeList: null,
  portfolioInvestmentList: null,
  portfolioSingleTradeList: null,
  portfolioSingleTrade: null,
};

export const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,

  extraReducers: {
    [getPortfolioInvestmentForm.fulfilled]: (state, { payload }) => {
      state.portfolioForm = payload.data;
    },

    [getPortfolioTradeAvgForm.fulfilled]: (state, { payload }) => {
      state.portfolioForm = payload.data;
    },

    [getPortfolioChart.fulfilled]: (state, { payload }) => {
      state.portfolioChart = payload.data;
    },

    [getPortfolioTradeAvgList.fulfilled]: (state, { payload }) => {
      state.portfolioTradeList = payload.data;
    },

    [getPortfolioInvestmentList.fulfilled]: (state, { payload }) => {
      state.portfolioInvestmentList = payload.data;
    },

    [getPortfolioTradeAvgForCoinList.fulfilled]: (state, { payload }) => {
      state.portfolioSingleTradeList = payload.data;
    },

    [getPortfolioTradeAvgForCoin.fulfilled]: (state, { payload }) => {
      state.portfolioSingleTrade = payload.data;
    },
  },
});

export default portfolioSlice.reducer;
